// API: use REACT_APP_API_URL (definida no build, ex.: Heroku Config Vars)
const API_BASE_URL = process.env.REACT_APP_API_URL || "https://api.innpsicologia.com.br/api";

export const getApiUrl = (endpoint) => `${API_BASE_URL}/${endpoint}`;

export default API_BASE_URL;